const selectors = {
  toggleDrawer: '[data-toggle-pdp-size-guide]',
  sizeGuideDrawer: '[data-pdp-size-guide-drawer]',
  radioInputs: 'input[name="size-guide-unit"]',
  sizeGuideTable: '.size-guide__table',
  sizeGuideToolTip: '.size-guide__tooltip',
  showMoreModels: '.size-guide__models-show-more',
  models: '.size-guide__model',
};

const classes = {
  active: 'size-guide--active',
  toolTipHidden: 'size-guide__tooltip--hidden',
  modelActive: 'size-guide__model--active',
};

function pdpSizeGuide() {
  const toggleDrawerElements = document.querySelectorAll(selectors.toggleDrawer);
  const sizeGuideDrawer = document.querySelector(selectors.sizeGuideDrawer);
  if (!toggleDrawerElements || !sizeGuideDrawer) return;

  const radioInputs = document.querySelectorAll(selectors.radioInputs);
  const sizeGuideTableWrapper = document.querySelector(selectors.sizeGuideTable);
  const sizeGuideTable = sizeGuideTableWrapper?.querySelector('table');
  const showMoreModels = sizeGuideDrawer?.querySelector(selectors.showMoreModels);
  const models = sizeGuideDrawer?.querySelectorAll(selectors.models);

  toggleDrawerElements.forEach((toggleElement) => {
    toggleElement.addEventListener('click', () => {
      sizeGuideDrawer.classList.toggle(classes.active);
    });
  });

  function appendToolTip() {
    const secondRowHeader = sizeGuideTable.querySelector('tr:nth-of-type(2) th');
    const toolTip = document.querySelector(selectors.sizeGuideToolTip);

    if (!secondRowHeader || !toolTip) return;
    secondRowHeader.appendChild(toolTip);

    toolTip.classList.remove(classes.toolTipHidden);
  }

  function updateTableUnits(unit) {
    const tableCells = document.querySelectorAll(`${selectors.sizeGuideTable} td`);

    tableCells.forEach((cell) => {
      const cellValue = cell.textContent;
      let values = cellValue.split('/').map(parseFloat);

      if (unit === 'INCH') {
        values = values.map((value) => Math.round((value / 2.54) * 2) / 2);
        cell.dataset.inches = values.join('/');
      }
    });

    sizeGuideTableWrapper.dataset.units = unit;
  }

  if (!radioInputs || !sizeGuideTable) return;

  function checkInitiallySelected() {
    const checkedInput = document.querySelector(`${selectors.radioInputs}:checked`);

    if (checkedInput) {
      updateTableUnits(checkedInput.value);
    }
  }

  checkInitiallySelected();
  appendToolTip();

  radioInputs.forEach(function (input) {
    input.addEventListener('change', function (event) {
      if (event.target.checked) {
        updateTableUnits(event.target.value);
      }
    });
  });

  if (!showMoreModels || !models) return;

  showMoreModels.addEventListener('click', () => {
    models.forEach((model, i) => {
      if (i < 1) return;
      model.classList.toggle(classes.modelActive);
      showMoreModels.style.display = 'none';
    });
  });
}

export default pdpSizeGuide;
